/**
 * @typedef {Object} OpenFileDialogOptions
 * @property {boolean} multiple
 * @property {string|string[]} accept The file-input accept attribute
 */

/**
 * Opens the browsers file dialog to choose file(s).
 *
 * @param {OpenFileDialogOptions=} options
 */
export async function OpenFileDialog(options = {}) {
	return new Promise(resolve => {
		const fileInput = document.createElement("input");
		fileInput.style.display = "none";
		fileInput.setAttribute("type", "file");

		if(options.multiple)
			fileInput.setAttribute("multiple", "");

		if(options.accept)
			fileInput.setAttribute("accept", Array.isArray(options.accept) ? options.accept.join(",") : options.accept);

		fileInput.addEventListener("change", () => {
			document.body.removeChild(fileInput);

			if(fileInput.files.length > 0)
				resolve(Array.from(fileInput.files));
		});

		/**
		 * Needs to attach input to DOM, because iOS will not detect file selection also sometimes other browsers.
		 *
		 * @link https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only/47665517#47665517
		 */
		document.body.appendChild(fileInput);

		// Triggers the input "click" which will trigger the native file dialog to open.
		try {
			// Mobile Safari (iOS) Fix
			const clickEvent = new MouseEvent("click");
			fileInput.dispatchEvent(clickEvent);
		} catch(e) {
			// Fallback for Non-Mobile Browsers
			fileInput.click();
		}
	});
}

export default OpenFileDialog;